let StableCountryList;
var map;

var tileMapLayer = L.tileLayer.provider('CartoDB.VoyagerLabelsUnder');
//var tileMapLayer = new L.TileLayer('http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png');

customCircleMarker = L.CircleMarker.extend({
    options: {
        country: 'countrydefault'
    }
});

var mapOptions = {
    center: [22.93151, 8.072205],
    zoom: 3
}



$(document).ready(function () {
    const onIntersection = (entries, whereToFindUsObserver) => {
        for (const { isIntersecting, target } of entries) {
            if (isIntersecting) {
                StableCountryList = getStableCountryList();
                displaySearchText(true);
                addCountriesToMap(mapOptions, StableCountryList);
                whereToFindUsObserver.unobserve(target);
                
            }
        }
    };

    const options = {
        //root: $("#mi-corpo-wheretofindus"),
        threshold: [0.1]
    };

    /**
     * Select the demo element, create an observer and start observing the demo element.
     */
    let target = document.querySelector('#mi-corpo-wheretofindus');
    const whereToFindUsObserver = new IntersectionObserver(onIntersection, options);

    whereToFindUsObserver.observe(target);
  
    
    $("#mi-corpo-wheretofindus-search").on('input',function () {
        var partialCountry = $("#mi-corpo-wheretofindus-search").val();
        searchPartialCountry(partialCountry);
    });


    $(document.body).on('click', ".mi-corpo-wheretofindus-country-item", function () {
        var country = $(this).text();
        searchContactsByCountry(country);
        displaySearchText(false);

    });

    $(document.body).on('click', "#mi-corpo-wheretofindus-arrowback-button", function () {
        searchPartialCountry();
        displaySearchText(true);
    });

    $(document.body).on('click', ".mi-corpo-wheretofindus-contactus-button", function () {
        var contactusButtonLink = $("#mi-corpo-wheretofindus-contactus-button-link").val();
        location.href = contactusButtonLink;
    });

});

function searchContactsByCountry(country) {
    var options = {
        url: "/elcawheretofindus/searchContactsByCountry",
        data: "country=" + country,
        type: "PUT",
        success: function (result) {
            deserializeListContacts(result);
        },
        error: function () {
            alert("Error loading the countries.");
        }
    };
    return $.ajax(options);

}

function searchPartialCountry(country) {
    var finalCountryList = [];

    for (let i = 0; i < StableCountryList.length; i++) {
        if (country == null || country == "") {
            finalCountryList.push(StableCountryList[i]);
        }
        else if (StableCountryList[i].name.toLowerCase().includes(country.toLowerCase())) {
            finalCountryList.push(StableCountryList[i]);
        }
    }

    var $htmlSelection = $(".mi-corpo-wheretofindus-list");
    var htmlFinal="";
    $htmlSelection.empty();
    for (i = 0; i < finalCountryList.length; i++) {
        var html = '<div class="row col-12 mi-corpo-wheretofindus-country"><div class="col-10 mi-corpo-wheretofindus-country-item">' + finalCountryList[i].name + '</div><div class="col-2"><i class="mi-corpo-wheretofindus-country-arrow"></i></div></div>';
        htmlFinal += html;
    }

    $htmlSelection.html(htmlFinal);
    addCountriesToMap(mapOptions, StableCountryList);


}

function deserializeListContacts(contactsString) {

    const siteId = $('html').attr('data-site-id');

    const imagesSourcePath = '/ResourcePackages/BootStrap4MI/assets/dist/sprites/';
    const locatorImageSource = imagesSourcePath + siteId + '-locator.svg';
    const phoneImageSource = imagesSourcePath + siteId + '-phone.svg';
    const technicalImageSource = imagesSourcePath + siteId + '-technical.svg';
    const assistantImageSource = imagesSourcePath + siteId + '-assistant.svg';

    let contacts = JSON.parse(contactsString);
    let contactusButtonText = $("#mi-corpo-wheretofindus-contactus-text").val();
    let technicalSupport = $("#mi-corpo-wheretofindus-technicalsupport").val();
    let customerCare = $("#mi-corpo-wheretofindus-customercare").val();

    var $htmlSelection = $(".mi-corpo-wheretofindus-list");
    $htmlSelection.empty();
    let htmlFinal = "";

    for (i = 0; i < contacts.length; i++) {
        let html = '<div class="row col-12 mi-corpo-wheretofindus-contact">' +
            '<div class="row col-12 mi-corpo-wheretofindus-contact-name">' + (i + 1) + '.' + contacts[i].FirmName + '</div>' +
            '<div class="row col-12 mi-corpo-wheretofindus-contact-address"><img class="mi-corpo-wheretofindus-contact-icon" src="' + locatorImageSource + '">' + contacts[i].Address1 + " " + contacts[i].Address2 + " " + contacts[i].Address3 + '</div>' +
            '<div class="row col-12 mi-corpo-wheretofindus-contact-phone"><img class="mi-corpo-wheretofindus-contact-icon" src="' + phoneImageSource + '">' + contacts[i].Phone + '</div>';
        if (contacts[i].PhoneTechnical != null & contacts[i].PhoneTechnical != "") {
            html += '<div class="row col-12 mi-corpo-wheretofindus-contact-phonetitle">' + technicalSupport + '</div><div class="row col-12 mi-corpo-wheretofindus-contact-phonesupport"><img class="mi-corpo-wheretofindus-contact-icon" src="' + technicalImageSource + '">' + contacts[i].PhoneTechnical + '</div>';
        }
        if (contacts[i].PhoneCustomer != null & contacts[i].PhoneCustomer != "") {
            html += '<div class="row col-12 mi-corpo-wheretofindus-contact-phonetitle">' + customerCare + '</div><div class="row col-12 mi-corpo-wheretofindus-contact-phonecustomer"><img class="mi-corpo-wheretofindus-contact-icon" src="' + assistantImageSource + '">' + contacts[i].PhoneCustomer + '</div>';
        }
        html += '<div class="row col-12 mi-corpo-wheretofindus-contact-button"><button class="mi-corpo-wheretofindus-contactus-button">' + contactusButtonText + '<i class="mi-corpo-vertical-align-middle material-icons mi-corpo-wheretofindus-buttonarrow" style="font-size: 16px;">arrow_forward</i></button></div>';
        html += '</div > ';
            
        htmlFinal += html;
    }
    $htmlSelection.html(htmlFinal);
    addContactsToMap(contacts)
}

function displaySearchText(activate) {
    if (activate == true) {
        $('#mi-corpo-wheretofindus-search').css('display', 'inline');
        $('.mi-corpo-wheretofindus-search-container-icon').css('display', 'inline');
        $('#mi-corpo-wheretofindus-arrowback-button').css('display', 'none');

    }
    else{
        $('#mi-corpo-wheretofindus-search').css('display', 'none');
        $('.mi-corpo-wheretofindus-search-container-icon').css('display', 'none');
        $('#mi-corpo-wheretofindus-arrowback-button').css('display', 'block');
    }
}

function onMarkerClick(e) {
    searchContactsByCountry(e.target.options.country);
    displaySearchText(false);
}


function addCountriesToMap(mapOptions, countryList) {
    if (map) {
        map.remove();
    }
    
    map = new L.map('mi-corpo-wheretofindus-map', mapOptions);
    map.addLayer(tileMapLayer);

    for (var i = 0; i < countryList.length; i++) {
        var markerOptions = { radius: 17, opacity: 1, color: "var(--primary-color-01)", fill: true, fillOpacity: 1, country: countryList[i].name };
        var marker = new customCircleMarker([countryList[i].lat, countryList[i].lon], markerOptions);
        marker.on('click', onMarkerClick);
        marker.addTo(map);
        if (countryList[i].nc > 1) {
            if (countryList[i].nc > 1) {
                var markerAddOptions = { radius: 27, opacity: 0, color: "var(--primary-color-01)", fill: true, fillOpacity: 0.5, country: countryList[i].name};
                var markerAdd = new customCircleMarker([countryList[i].lat, countryList[i].lon], markerAddOptions);
                markerAdd.on('click', onMarkerClick);
                markerAdd.addTo(map);
            }
            
            if (countryList[i].nc > 2) {
                var markerAddOptions = { radius: 37, opacity: 0, color: "var(--primary-color-01)", fill: true, fillOpacity: 0.1, country: countryList[i].name};
                var markerAdd = new customCircleMarker([countryList[i].lat, countryList[i].lon], markerAddOptions);
                markerAdd.on('click', onMarkerClick);
                markerAdd.addTo(map);
            }
            
        }
        var tooltip = new L.tooltip({
            permanent: true,
            direction: 'center',
            className: 'mi-corpo-wheretofindus-circlemarker-text'
        }).setContent(countryList[i].nc.toString()).setLatLng([countryList[i].lat, countryList[i].lon]);
        tooltip.addTo(map);

    }

}

function addContactsToMap(contactList) {
    

    for (var i = 0; i < contactList.length; i++) {
        if (i == 0) {
            var mapOptions = {
                center: [parseFloat(contactList[i].Lat), parseFloat(contactList[i].Lon)],
                zoom: 5
            }
            map.remove();
            map = new L.map('mi-corpo-wheretofindus-map', mapOptions);
            
            map.addLayer(tileMapLayer);
        }
        var marker = new L.marker([parseFloat(contactList[i].Lat), parseFloat(contactList[i].Lon)]);
        marker.addTo(map);
        var tooltip = new L.tooltip({
            permanent: true,
            direction: 'center',
            className: 'mi-corpo-wheretofindus-marker-text'
        }).setContent((i + 1).toString()).setLatLng([contactList[i].Lat, contactList[i].Lon]);
        tooltip.addTo(map);
    }

}

function removeLeafletTooltipClass() {
    $(".mi-corpo-wheretofindus-circlemarker-text").removeClass("leaflet-tooltip");
    $(".mi-corpo-wheretofindus-marker-text").removeClass("leaflet-tooltip");

}


$(window).resize(function () {

    if ($(window).width() <= 750) {
        $('#mi-corpo-wheretofindus-map').css('display', 'none');
    }
    else {
        $('#mi-corpo-wheretofindus-map').css('display', 'block');
    }

});

